/** Results number */
export const RESULTS_NUMBER = {
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
};
